<template>
    <div>
        <div v-if="$store.state.loading && view == 'grid' && !$store.state.mobile">
            <content-loader class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader  class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader  class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader  class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader  class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader  class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
            <content-loader  class="gridLoader" :width="235" :height="400" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="15" y="192" rx="0" ry="0" width="215" height="16" />
                <rect x="17" y="220" rx="0" ry="0" width="198" height="9" />
                <rect x="17" y="239" rx="0" ry="0" width="273" height="9" />
                <rect x="17" y="256" rx="0" ry="0" width="150" height="9" />
                <rect x="17" y="275" rx="0" ry="0" width="180" height="9" />
                <rect x="17" y="296" rx="0" ry="0" width="214" height="30" />
                <rect x="15" y="30" rx="0" ry="0" width="214" height="144" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
                <rect x="16" y="334" rx="0" ry="0" width="214" height="30" />
            </content-loader>
        </div>
        <div v-if="$store.state.loading && $store.state.mobile">
            <content-loader :width="345" :height="600" :speed="0.5" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="13" y="471" rx="0" ry="0" width="311" height="53" />
                <rect x="8" y="24" rx="0" ry="0" width="306" height="17" />
                <rect x="13" y="336" rx="0" ry="0" width="198" height="9" />
                <rect x="13" y="355" rx="0" ry="0" width="273" height="9" />
                <rect x="13" y="372" rx="0" ry="0" width="150" height="9" />
                <rect x="13" y="391" rx="0" ry="0" width="180" height="9" />
                <rect x="12" y="414" rx="0" ry="0" width="311" height="52" />
                <rect x="18" y="81" rx="0" ry="0" width="282" height="189" />
                <rect x="154" y="92" rx="0" ry="0" width="2" height="1" />
            </content-loader>
        </div>
        <div v-if="$store.state.loading && !$store.state.mobile && view == 'list'">
            <content-loader :width="600" :height="254" :speed="2" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="8" y="172" rx="0" ry="0" width="311" height="27" />
                <rect x="8" y="24" rx="0" ry="0" width="306" height="17" />
                <rect x="9" y="60" rx="0" ry="0" width="198" height="9" />
                <rect x="9" y="79" rx="0" ry="0" width="273" height="9" />
                <rect x="9" y="96" rx="0" ry="0" width="150" height="9" />
                <rect x="9" y="115" rx="0" ry="0" width="180" height="9" />
                <rect x="8" y="138" rx="0" ry="0" width="311" height="27" />
            </content-loader>
            <content-loader :width="600" :height="254" :speed="2" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="8" y="172" rx="0" ry="0" width="311" height="27" />
                <rect x="8" y="24" rx="0" ry="0" width="306" height="17" />
                <rect x="9" y="60" rx="0" ry="0" width="198" height="9" />
                <rect x="9" y="79" rx="0" ry="0" width="273" height="9" />
                <rect x="9" y="96" rx="0" ry="0" width="150" height="9" />
                <rect x="9" y="115" rx="0" ry="0" width="180" height="9" />
                <rect x="8" y="138" rx="0" ry="0" width="311" height="27" />
            </content-loader>
            <content-loader :width="600" :height="254" :speed="2" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="8" y="172" rx="0" ry="0" width="311" height="27" />
                <rect x="8" y="24" rx="0" ry="0" width="306" height="17" />
                <rect x="9" y="60" rx="0" ry="0" width="198" height="9" />
                <rect x="9" y="79" rx="0" ry="0" width="273" height="9" />
                <rect x="9" y="96" rx="0" ry="0" width="150" height="9" />
                <rect x="9" y="115" rx="0" ry="0" width="180" height="9" />
                <rect x="8" y="138" rx="0" ry="0" width="311" height="27" />
            </content-loader>
            <content-loader :width="600" :height="254" :speed="2" primaryColor="#d6d6d6" secondaryColor="#ecebeb">
                <rect x="354" y="23" rx="0" ry="0" width="251" height="167" />
                <rect x="8" y="172" rx="0" ry="0" width="311" height="27" />
                <rect x="8" y="24" rx="0" ry="0" width="306" height="17" />
                <rect x="9" y="60" rx="0" ry="0" width="198" height="9" />
                <rect x="9" y="79" rx="0" ry="0" width="273" height="9" />
                <rect x="9" y="96" rx="0" ry="0" width="150" height="9" />
                <rect x="9" y="115" rx="0" ry="0" width="180" height="9" />
                <rect x="8" y="138" rx="0" ry="0" width="311" height="27" />
            </content-loader>
        </div>
    </div>
</template>

<script>
    import {
        ContentLoader
    } from 'vue-content-loader'
    export default {
        components: {
            ContentLoader
        },
        props: ["view"]
    }
</script>

<style lang="scss" scoped>
 .gridLoader {
     	display: inline-block;
	width: 32%;
 }
</style>